import * as RadixSlider from '@radix-ui/react-slider';

import { cx } from '@/shared/lib/cx';

import styles from './Slider.module.scss';

export interface SliderProps {
  min: number;
  max: number;
  step?: number;
  /** null — значение не задано: ползунок стоит в начале, но число не показано. */
  value: number | null;
  onValueChange: (value: number) => void;
  'aria-label'?: string;
  className?: string;
  disabled?: boolean;
}

/**
 * Ползунок для числа между минимумом и максимумом. Число рядом — чтобы
 * выбранное значение было видно точно, а не «где-то на трети».
 */
export function Slider({
  min,
  max,
  step = 1,
  value,
  onValueChange,
  className,
  ...rest
}: SliderProps) {
  return (
    <div className={cx(styles['slider'], className)}>
      <RadixSlider.Root
        className={styles['slider__root']}
        min={min}
        max={max}
        step={step}
        value={[value ?? min]}
        onValueChange={([next]) => {
          if (next !== undefined) {
            onValueChange(next);
          }
        }}
        {...rest}
      >
        <RadixSlider.Track className={styles['slider__track']}>
          <RadixSlider.Range className={styles['slider__range']} />
        </RadixSlider.Track>
        <RadixSlider.Thumb className={styles['slider__thumb']} aria-label={rest['aria-label']} />
      </RadixSlider.Root>
      <output className={styles['slider__value']}>{value ?? '—'}</output>
    </div>
  );
}
